import { ApolloError, gql, useMutation } from "@apollo/client";
import { DelGoodReviewPosterMutation } from "../gql/graphql";

const DEL_GOOD_REVIEW_POSTER_MUTATION = gql`
  mutation delGoodReviewPoster($input: DelGoodReviewPosterInput!) {
    delGoodReviewPoster(input: $input) {
      ok
      err
    }
  }
`;

export const useDelReviewPoster = (onCompleted?: (data: DelGoodReviewPosterMutation) => void, onError?: (error: ApolloError) => void) => {
  return useMutation<DelGoodReviewPosterMutation>(DEL_GOOD_REVIEW_POSTER_MUTATION, {
    onCompleted,
    onError,
    fetchPolicy: "network-only",
  });
};
